module.exports = __webpack_public_path__ + "static/media/sofaSingle.3cb949a6.svg";